import React, { Component, useEffect } from "react";
import { Modal } from "react-bootstrap";
import $ from "jquery";
import RegistrationsService from "../../RegistrationsService";
import registrationsAction from "../../../../store/registrations/action";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import StepOne from "../RegDetails/Wizard/stepOne";
import StepThree from "../RegDetails/Wizard/stepThree";
import StepTwo from "../RegDetails/Wizard/stepTwo";
import "../RegDetails/Wizard/steps-prog.css";
import CloseRegistrationWizardModal from "./CloseRegistrationWizardModal";
import { Formik, Form } from "formik";
import { initForm, makeuid } from "../../Helpers/QuestionsFormUtils";
import SucessfulPayment from "../../../Payments/SucessfulPayment";
import AdminDeferredPaymentSuccess from "../../../Payments/AdminDeferredPaymentSuccess";
import PaymentDeferralBadge from "../RegDetails/Wizard/PaymentDeferralBadge";
import Portal from "@material-ui/core/Portal";
import { toast } from "react-toastify";
import {
  RegistrationTableTypes,
  RegistrationStatuses,
  RegisWizardCloseActions,
  PaymentStatuses,
  SessionStaus,
  RegisWizardSteps,
} from "../../Helpers/LookUpValues";
import _ from "lodash";
import PaymentService from "../../../Payments/PaymentService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { debounce } from "throttle-debounce";

const initialState = {
  showConfirmCloseRegModal: false,
  currentStep: 0, // Default is Step 0
  isExecutePaymentFlow: false,
  isFinishedPaymentFlow: false,
  isFailedPaymentFlow: false,
  anyRequiredFeeQuestions: false,
  anyFeeQuestions: false,
  steps: [
    {
      key: RegisWizardSteps.FirstStep,
      label: "Details",
      isDone: false,
    },
    {
      key: RegisWizardSteps.SecondStep,
      label: "Questions",
      isDone: false,
    },
    {
      key: RegisWizardSteps.ThirdStep,
      label: "Payment",
      isDone: false,
    },
    {
      key: RegisWizardSteps.FourthStep,
      label: "Success",
      isDone: false,
    },
  ],
  paymentSteps: [
    {
      key: RegisWizardSteps.ThirdStep,
      label: "Payment",
      isDone: false,
    },
    {
      key: RegisWizardSteps.FourthStep,
      label: "Success",
      isDone: false,
    },
  ],
  successStep: {
    key: RegisWizardSteps.FourthStep,
    label: "Success",
    isDone: false,
  },

  activeStep: {
    key: RegisWizardSteps.FirstStep,
    label: "Registration Details",
    isDone: false,
  },
  initialValues: [],
  validationSchema: {},
  pauseRegistration: false,
  wizardBtnCloseAction: 0,
  prevValues: [],
  rawQuestionData: [],
  questionsFee: 0,
  // Admin on-behalf state
  selectedTargetMemberId: null,
  selectedTargetMemberName: "",
  memberOptions: [],
  searchTerm: "",
};
class RegisterMemberModal extends Component {
  constructor(props) {
    super(props);
    // Set the initial input values
    // Bind new functions for next and previous
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
    this.portalRef = React.createRef();
    this.state = {
      ...initialState,
    };

    // Initialize debounced search (500ms delay)
    this.autocompleteSearchDebounced = debounce(500, this.autocompleteSearch);

    // Bind the submission to handleChange()
    this.handleChange = this.handleChange.bind(this);
    this.handleTargetMemberSelection = this.handleTargetMemberSelection.bind(this);
    this.confirmCancelRegModal = () => {
      this.confirmed = async (callSubmitForm, closeBtnAct, setFormErrors) => {
        this.setState(
          { pauseRegistration: true, wizardBtnCloseAction: closeBtnAct },
          () => {
            //setFormErrors({});
            callSubmitForm();
          }
        );
      };

      return this;
    };
  }

  // Helper method to calculate fee based on current form values
  calculateQuestionsFee(values) {
    if (!values || !this.state.rawQuestionData) return 0;

    const allFeeAssocQues = this.state.rawQuestionData
      .filter((f) => f.isFeeAssociated)
      .map((m) => m.uid);

    const feeAnswersKeys = Object.keys(values).filter(
      (f) => allFeeAssocQues.includes(f) && values[f]
    );

    const totalFee = this.state.rawQuestionData
      .filter((f) => feeAnswersKeys.includes(f.uid))
      .reduce((accumulator, object) => {
        return accumulator + (object.fee || 0);
      }, 0);

    return totalFee;
  }

  // Helper method to check if any fee questions are answered
  checkAnyFeeQuestionAnswered(values) {
    if (!values || !this.state.rawQuestionData) return false;

    const allFeeAssocQues = this.state.rawQuestionData
      .filter((f) => f.isFeeAssociated)
      .map((m) => m.uid);

    return Object.keys(values)
      .filter((f) => allFeeAssocQues.includes(f))
      .some((key) => values[key]);
  }

  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  // Member search handler with debouncing
  memberSearchHandler = (searchTerm) => {
    this.setState({ searchTerm: searchTerm }, () => {
      this.autocompleteSearchDebounced();
    });
  }

  // Debounced autocomplete search
  autocompleteSearch = () => {
    this.loadMemberData();
  }

  // Load member data from API
  loadMemberData = async () => {
    const { searchTerm } = this.state;
    if (!searchTerm || searchTerm.length < 2) return;

    let data = await RegistrationsService.LoadMembers(searchTerm, 0, 10);
    if (!_.isEmpty(data) && data.statusCode == 200) {
      this.setState({ memberOptions: data.result || [] });
    }
  }

  handleTargetMemberSelection(e, value) {
    const { isRegisteringForOthers } = this.props;

    if (value) {
      // Admin selected a target member - switch to on-behalf registration flow
      this.setState({
        selectedTargetMemberId: value.id,
        selectedTargetMemberName: `${value.name || `${value.firstName || ""} ${value.lastName || ""}`}`.trim(),
      }, () => {
        // Recalculate steps if we're on step 2 and there are fee questions
        if (isRegisteringForOthers && this.state.anyFeeQuestions && this.state.currentStep === 1) {
          this.adjustStepsForAdminRegistration();
        }
      });
    } else {
      // Admin deselected target member - switch back to self-registration flow
      this.setState({
        selectedTargetMemberId: null,
        selectedTargetMemberName: ""
      }, () => {
        // Recalculate steps if we're on step 2 and there are fee questions
        if (isRegisteringForOthers && this.state.anyFeeQuestions && this.state.currentStep === 1) {
          this.adjustStepsForSelfRegistration();
        }
      });
    }
  }

  // Helper method to adjust steps for admin-on-behalf registration
  adjustStepsForAdminRegistration() {
    const { steps } = this.state;
    const hasPaymentStep = steps.findIndex((n) => n.key === RegisWizardSteps.ThirdStep) !== -1;
    const hasSuccessStep = steps.findIndex((n) => n.key === RegisWizardSteps.FourthStep) !== -1;

    // Remove both payment and success steps for admin on-behalf registration
    // Payment is deferred to target member, so there's no payment flow or success step
    if (hasPaymentStep || hasSuccessStep) {
      const filteredSteps = steps.filter(
        (s) => s.key !== RegisWizardSteps.ThirdStep && s.key !== RegisWizardSteps.FourthStep
      );
      this.setState({
        steps: filteredSteps,
        isExecutePaymentFlow: false,
      });
    }
  }

  // Helper method to adjust steps for self-registration
  adjustStepsForSelfRegistration() {
    const { steps, paymentSteps, isFinishedPaymentFlow } = this.state;
    const hasPaymentStep = steps.findIndex((n) => n.key === RegisWizardSteps.ThirdStep) !== -1;

    // Add payment steps back if fee questions are answered and payment isn't finished
    if (!hasPaymentStep && !isFinishedPaymentFlow) {
      const filteredSteps = steps.filter((s) => s.key !== RegisWizardSteps.FourthStep);
      this.setState({
        steps: [...filteredSteps, ...paymentSteps],
        isExecutePaymentFlow: true,
      });
    }
  }

  // Helper method to update payment step visibility based on current state
  updatePaymentStepVisibility(anyFeeQuestionAnswered) {
    const {
      isRegisteringForOthers,
      registrationRow,
      regisExists,
    } = this.props;
    const {
      steps,
      isFinishedPaymentFlow,
      successStep,
      paymentSteps,
      isExecutePaymentFlow,
    } = this.state;

    const isPendingPayment = registrationRow && registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember;
    const hasPaymentSteps = steps.findIndex((n) => n.key === RegisWizardSteps.ThirdStep) !== -1 ||
                            steps.findIndex((n) => n.key === RegisWizardSteps.FourthStep) !== -1;

    if (
      !registrationRow ||
      registrationRow.regisStatusId === 0 ||
      registrationRow.regisStatusId === RegistrationStatuses.InProgress ||
      registrationRow.regisStatusId === RegistrationStatuses.PendingRegistration ||
      isPendingPayment
    ) {
      if (anyFeeQuestionAnswered || isPendingPayment) {
        // Only skip payment if admin has ACTUALLY selected a target member
        const isAdminRegisteringForOther =
          isRegisteringForOthers &&
          this.state.selectedTargetMemberId &&
          anyFeeQuestionAnswered;

        if (!hasPaymentSteps) {
          // Payment steps don't exist, need to add them
          if (isAdminRegisteringForOther) {
            // Admin registering for another member - no payment or success steps
            // Payment is deferred, just keep Steps 1 and 2
            this.setState({
              isExecutePaymentFlow: false,
            });
          } else if (isFinishedPaymentFlow) {
            // Normal self-registration with finished payment - show success step only
            this.setState({
              steps: [...steps, successStep],
            });
          } else {
            // Show payment step for normal flow or admin self-registration
            this.setState({
              steps: [...steps, ...paymentSteps],
              isExecutePaymentFlow: true,
            });
          }
        } else {
          // Payment steps exist, just ensure correct flow state
          if (isAdminRegisteringForOther && isExecutePaymentFlow) {
            // Admin on-behalf registration - remove both payment and success steps
            var filteredSteps = this.state.steps.filter(
              (s) =>
                s.key !== RegisWizardSteps.ThirdStep &&
                s.key !== RegisWizardSteps.FourthStep
            );
            this.setState({
              steps: filteredSteps,
              isExecutePaymentFlow: false,
            });
          } else if (!isAdminRegisteringForOther && !isExecutePaymentFlow) {
            // Need to switch from no-payment to payment
            this.setState({
              isExecutePaymentFlow: true,
            });
          }
        }
      } else {
        // No fee questions answered - remove payment steps if they exist
        if (hasPaymentSteps || isExecutePaymentFlow) {
          var filteredSteps = this.state.steps.filter(
            (s) =>
              s.key !== RegisWizardSteps.ThirdStep &&
              s.key !== RegisWizardSteps.FourthStep
          );
          this.setState({
            steps: filteredSteps,
            isExecutePaymentFlow: false,
          });
        }
      }
    }
  }
  // Test current step with ternary
  // _next and _previous functions will be called on button click
  _next() {
    ///console.log("submitForm", this.submitForm);
    //this.submitForm.click();
    let { currentStep, steps, activeStep } = this.state;
    const { isRegisteringForOthers } = this.props;
    const index = steps.findIndex((x) => x.key === activeStep.key);
    let maxLength = steps.length - 1;

    // Check if we're moving from Step 1 to Step 2 and need to recalculate steps
    const isMovingFromStep1ToStep2 =
      activeStep.key === RegisWizardSteps.FirstStep &&
      index + 1 < steps.length &&
      steps[index + 1].key === RegisWizardSteps.SecondStep;

    if (isMovingFromStep1ToStep2 && isRegisteringForOthers && this.state.anyFeeQuestions) {
      // Recalculate steps based on whether a target member is selected
      if (this.state.selectedTargetMemberId) {
        // Admin selected a target member - remove payment/success steps
        this.adjustStepsForAdminRegistration();
      } else {
        // Admin deselected or never selected target - ensure payment steps are present
        this.adjustStepsForSelfRegistration();
      }

      // After adjusting steps, we need to use setTimeout to ensure state update completes
      // before proceeding with navigation
      setTimeout(() => {
        this._proceedToNextStep();
      }, 0);
      return;
    }

    // Normal navigation without step adjustment
    this._proceedToNextStep();
  }

  _proceedToNextStep() {
    let { currentStep, steps, activeStep } = this.state;
    const index = steps.findIndex((x) => x.key === activeStep.key);
    let maxLength = steps.length - 1;

    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep >= maxLength ? maxLength : currentStep + 1;
    this.setState({
      currentStep: currentStep,
    });
    let item = { ...steps[index] };

    item.isDone = true;
    steps[index] = item;

    this.setState({ activeStep: steps[index + 1] });

    this.setState({ steps });
  }

  _prev() {
    let { currentStep, steps, activeStep } = this.state;
    // If the current step is 2 or 3, then subtract one on "previous" button click
    let firstStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.FirstStep
    );
    if (currentStep <= firstStepIdx) {
      return;
    }
    currentStep = currentStep <= firstStepIdx ? firstStepIdx : currentStep - 1;
    this.setState({
      currentStep: currentStep,
    });
    const index = steps.findIndex((x) => x.key === activeStep.key);

    let item = { ...steps[currentStep] };

    item.isDone = false;
    steps[currentStep] = item;

    this.setState({ activeStep: steps[index - 1] });

    this.setState({ steps });
  }
  showPaymentSuccess = () => {
    let { steps } = this.state;

    let modifiedSteps = steps
      .map((m) => {
        if (m.key != RegisWizardSteps.FourthStep) return { ...m, isDone: true };
        else {
          return { ...m, isDone: false };
        }
      })
      .filter((s) => s.key !== RegisWizardSteps.ThirdStep); // exclude Payment Step
    let fourthStepIdx = modifiedSteps.findIndex(
      (f) => f.key == RegisWizardSteps.FourthStep
    );
    if (fourthStepIdx != -1) {
      this.setState({ steps: modifiedSteps }, () => {
        this.setState({ activeStep: modifiedSteps[fourthStepIdx] });
        this.setState({ currentStep: fourthStepIdx });
      });
    }
  };
  // The "next" and "previous" button functions
  get previousButton() {
    let { currentStep, steps } = this.state;
    let firstStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.FirstStep
    );
    // If the current step is not 0, then render the "previous" button
    if (currentStep !== firstStepIdx) {
      return (
        <button
          className="btn btn-info mr-1"
          type="button"
          onClick={this._prev}
        >
          <i class="fa fa-chevron-circle-left" aria-hidden="true">
            Previous
          </i>
        </button>
      );
    }
    return null;
  }

  get nextButton() {
    let { currentStep, steps } = this.state;
    // If the current step is not last step, then render the "next" button
    let lastStepIdx = steps.length - 1;
    if (currentStep < lastStepIdx) {
      return (
        <button className="btn btn-success" type="button" onClick={this._next}>
          <i class="fa fa-arrow-circle-right" aria-hidden="true">
            Next
          </i>
        </button>
      );
    }
    // ...else render nothing
    return null;
  }

  showSpinner = () => {
    $(".loading").show();
  };

  hideSpinner = () => {
    $(".loading").hide();
  };

  handleClose = () => {
    const { registrationRow, regisExists } = this.props;
    const { steps } = this.state;
    let secondStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.SecondStep
    );
    const isDisabled =
      registrationRow &&
      registrationRow.regisStatusId != RegistrationStatuses.InProgress &&
      registrationRow.regisStatusId !=
      RegistrationStatuses.PendingRegistration &&
      regisExists;
    if (
      (registrationRow.regisStatusId == RegistrationStatuses.InProgress ||
        registrationRow.regisStatusId ==
        RegistrationStatuses.PendingRegistration ||
        _.isEmpty(registrationRow.regisStatusId)) &&
      !isDisabled &&
      this.state.currentStep == secondStepIdx
    ) {
      this.toggleShowConfirmCloseRegModal();
    } else {
      this.justCloseRegModal();
    }
  };

  toggleShowConfirmCloseRegModal = () => {
    this.setState({
      showConfirmCloseRegModal: !this.state.showConfirmCloseRegModal,
    });
  };
  onShow = async () => {
    const { props } = this;
    const {
      occasionId,
      registrationId,
      paymentStatusId,
      showSuccessPage,
      registrationRow,
      regisExists,
      isRegisteringForOthers,
      targetMemberId,
    } = props;
    //debugger;
    if (occasionId) {
      this.showSpinner();
      this.setState(initialState);
      let relatedFunction;

      if (
        this.props.regTableType !== RegistrationTableTypes.MyRegistrations &&
        !registrationId
      ) {
        // No Registration-Id means no Questions have been Answered yet
        ///// When Opened from Opened Registrations Tab....
        relatedFunction = RegistrationsService.GetOccasionRegistrationQuestions;
        ///Right now only event id avaialble, Registration Id can be Generated only after
        ///Registration Wizard's Step 2......
      } else {
        //It would be the edit mode of MyRegistration's view mode..
        relatedFunction =
          RegistrationsService.GetOccasionRegQuestionsWithAnswers;
      }
      await relatedFunction(occasionId, registrationId)
        .then(async (data) => {
          if (data.statusCode == 200) {
            let questionsResponse = data.result;
            const anyFeeQuestions = questionsResponse.some((question) => {
              return question.isFeeAssociated;
            });
            const anyRequiredFeeQuestions = questionsResponse.some(
              (question) => {
                return question.isFeeAssociated && question.isRequired;
              }
            );
            this.setState({
              anyRequiredFeeQuestions: anyRequiredFeeQuestions,
              anyFeeQuestions: anyFeeQuestions,
            });
            console.log("paymentStatusId", paymentStatusId);
            if (paymentStatusId == PaymentStatuses.Success) {
              this.setState({
                isFinishedPaymentFlow: true,
              });
              var steps = this.state.steps.filter(
                (s) => s.key !== RegisWizardSteps.ThirdStep //Removed Payment Step
              );
              this.setState({
                steps: steps,
              });
            }
            if (
              anyFeeQuestions &&
              anyRequiredFeeQuestions &&
              registrationRow &&
              registrationRow.regisStatusId !=
              RegistrationStatuses.InProgress &&
              registrationRow.regisStatusId !=
              RegistrationStatuses.PendingRegistration &&
              regisExists
            ) {
              if (registrationId && paymentStatusId == PaymentStatuses.UnPaid) {
                //Check from Remote stripe API that, is the Payment really happended? or Our App is just Unsynced
                var response = await PaymentService.GetStripeSession(
                  registrationId
                );
                console.log("checking online status of payment");

                if (!_.isEmpty(response)) {
                  if (response.sessionStatus == SessionStaus.complete) {
                    this.setState({
                      isFinishedPaymentFlow: true,
                    });
                    this.showPaymentSuccess();
                    //Manually fullfill the Order
                    var response = await PaymentService.HandleCheckoutSuccess(
                      registrationId,
                      occasionId
                    );
                  }
                }
              } else if (
                registrationId &&
                paymentStatusId == PaymentStatuses.Success
              ) {
                this.setState({
                  isFinishedPaymentFlow: true,
                });
              }
              if (paymentStatusId == PaymentStatuses.Failed) {
                this.setState({
                  isFailedPaymentFlow: true,
                });
              }
              // if (
              //    paymentStatusId == 0 ||
              //    (paymentStatusId == null && registrationRow.IsSessionExists)
              //  ) {
              //  }
            }

            //this.setState({ questionsFee: totalFee }); //Amount for total Fee, used in Step3 Payment

            questionsResponse = questionsResponse.map((question) => ({
              ...question,
              uid: makeuid(5),
            }));
            this.setState({ rawQuestionData: questionsResponse });

            const questionsJson = questionsResponse.reduce(
              (obj, cur) => ({
                ...obj,
                [cur.uid]: cur,
              }),
              {}
            );
            this.props.setRegistrationQuestions(questionsJson);
            if (showSuccessPage) {
              this.showPaymentSuccess();
            }
            this.hideSpinner();
          } else {
            this.hideSpinner();
          }
        })
        .catch((error) => {
          this.hideSpinner();
        });
    }

    // prime selected target if provided via props
    if (isRegisteringForOthers && targetMemberId) {
      this.setState({ selectedTargetMemberId: targetMemberId });
    }

    let { selectedOpenRegQuestions } = this.props.registrationsState;
    let { _formData, _validationSchema } = initForm(selectedOpenRegQuestions);
    this.setState({ initialValues: _formData });
    this.setState({ validationSchema: _validationSchema });
    this.setState({ prevValues: _formData }, () => {
      // After initializing form, check if we need to show payment step
      // This handles the case when modal opens with existing answers
      const anyFeeQuestionAnswered = this.checkAnyFeeQuestionAnswered(_formData);
      this.updatePaymentStepVisibility(anyFeeQuestionAnswered);
    });
  };
  onSubmit = async (fields, helpers, details) => {
    console.log("details", details);
    let mySelf = this;
    const { currentStep, isExecutePaymentFlow, steps } = this.state;

    let secondStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.SecondStep
    );
    const {
      selectedOpenRegQuestions,
      //paymentStatus,
    } = this.props.registrationsState;
    let questionsWithAnswers = Object.entries(selectedOpenRegQuestions).map(
      (f) => ({
        value: fields[f[1].uid],
        id: f[1].id,
        questionType: f[1].questionType,
        isFeeAssociated: f[1].isFeeAssociated,
        fee: f[1].fee,
        answerMappingId: f[1].answerMappingId,
      })
    );

    let formData = {
      Questions: questionsWithAnswers,
      ChildTemplateId: this.props.occasionId,
      Registration_id: this.props.registrationId || 0,
      //PaymentStatus: paymentStatus,
      CloseBtnAction: this.state.wizardBtnCloseAction,
      CurrentStep: this.state.currentStep,
      TargetMemberId: (this.props.isRegisteringForOthers ? (this.state.selectedTargetMemberId || this.props.targetMemberId) : null) || null,
    };
    if (
      currentStep < 3 &&
      isExecutePaymentFlow &&
      !this.state.pauseRegistration
    ) {
      if (currentStep == secondStepIdx) {
        // Going forward from (Step(2)) of Answering Questions to Next Payment Screen(Step3)
        formData.CloseBtnAction = RegisWizardCloseActions.JustSaveAnswers; //Just Save the Question's Answers
        if (this.props.registrationId) {
          this._next();
        } else {
          await RegistrationsService.AddUpdateQuestionAnswers(formData).then(
            async (data) => {
              if (data && data.status && data.status == "Success") {
                await mySelf.props
                  .updateRegistrationId(data.registrationId)
                  .then(() => {
                    this._next();
                  });
              }
            }
          );
        }
      } else {
        this._next();
      }
    } else {
      //NO Payment Flow
      //It could be
      //1)Save&Close OR
      //2)Last Step Submit Action
      //3)PayNow Button
      //console.log("In onSubmit Method", JSON.stringify(formData));
      if (this.state.pauseRegistration) {
        formData.CloseBtnAction = this.state.wizardBtnCloseAction; //Should be Save&Close action
      } else {
        formData.CloseBtnAction = RegisWizardCloseActions.Submit; //Submit the Registration
      }
      await RegistrationsService.AddUpdateQuestionAnswers(formData).then(
        (data) => {
          if (data && data.status && data.status == "Success") {
            toast.success(data.message);
            if (this.state.pauseRegistration) {
              this.toggleShowConfirmCloseRegModal();
            }
            this.props.onClose();
          } else {
            toast.error("Something went wrong.");
          }
        }
      );

      ///this.props.reloadQuestions();
    }
  };
  justCloseRegModal = () => {
    this.props.onClose(); //No API hit
  };
  // validate = (values, props) => {
  //   let errors = { questions: [] };
  //   const { currentStep } = this.state;
  //   if (currentStep == 2) {
  //     const { questions } = values;
  //     questions.forEach((question, idx, allQuestions) => {
  //       if (
  //         (question.isRequired &&
  //           question.questionType == QuestionTypes.Text &&
  //           typeof question[question.uid] == "undefined") ||
  //         question[question.uid] == ""
  //       ) {
  //         errors.questions.push({ [question.uid]: "Required" });
  //       }
  //     });
  //   } else {
  //     errors = {};
  //   }
  //   console.log("In validate Method", JSON.stringify(errors));
  //   debugger;
  //   return errors;
  // };
  setPrevValues = (values) => {
    this.setState({ prevValues: values });
  };
  render() {
    const { selectedOpenRegRow, selectedOpenRegQuestions } =
      this.props.registrationsState || {};
    const { prevValues, steps, currentStep } = this.state;
    const {
      registrationRow,
      occasionId,
      registrationId,
      regisExists,
      paymentStatusId,
      isRegisteringForOthers,
    } = this.props;
    let fourthStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.FourthStep
    );
    let thirdStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.ThirdStep
    );
    let firstStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.FirstStep
    );
    let secondStepIdx = steps.findIndex(
      (i) => i.key == RegisWizardSteps.SecondStep
    );
    const isPendingPaymentByTarget = registrationRow && registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember;
    const showNextButton =
      currentStep == firstStepIdx ||
      (currentStep == secondStepIdx && isPendingPaymentByTarget) ||
      (registrationRow &&
        registrationRow.regisStatusId !== RegistrationStatuses.InProgress &&
        registrationRow.regisStatusId !==
        RegistrationStatuses.PendingRegistration &&
        (this.state.isExecutePaymentFlow || this.state.isFinishedPaymentFlow) &&
        regisExists);
    return (
      <Modal
        show={this.props.showModal}
        onHide={this.handleClose}
        size="xl"
        centered
        animation={true}
        backdrop="static"
        onShow={this.onShow}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="row">
              <div className="col-xs-12 col-sm-12">
                <h5 className="modal-title mt-0">
                  Registration
                  {`${selectedOpenRegRow &&
                    ` for "${selectedOpenRegRow.title}"
                `} ${selectedOpenRegRow &&
                      !_.isEmpty(selectedOpenRegRow.regisStatus)
                      ? "(" + (selectedOpenRegRow.regisStatus || "") + ")"
                      : ""
                    }`}
                </h5>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        {this.state.initialValues && (
          <Modal.Body className="modal-body">
            <>
              <Formik
                enableReinitialize
                initialValues={this.state.initialValues}
                validationSchema={
                  this.state.pauseRegistration
                    ? null
                    : this.state.validationSchema
                }
                onSubmit={this.onSubmit}
              //validate={this.validate}
              //validate={(values) => {
              // Validate the form using the Yup schema
              // try {
              //   this.state.validationSchema.validateSync(values, {
              //     abortEarly: false,
              //   });
              // } catch (error) {
              //   // Set the errors object using the information from the Yup error
              //   const errors = {};
              //   error.inner.forEach((err) => {
              //     errors[err.path] = err.message;
              //   });
              //   return {};
              // }
              //return {};
              //}}
              >
                {({
                  errors,
                  values,
                  touched,
                  setValues,
                  isValid,
                  handleSubmit,
                  setErrors,
                }) => {
                  this.formikValues = values;

                  // Use useEffect to handle form value changes and update payment steps
                  useEffect(() => {
                    const { prevValues } = this.state;

                    if (JSON.stringify(prevValues) !== JSON.stringify(values)) {
                      // Calculate fee immediately when values change
                      const calculatedFee = this.calculateQuestionsFee(values);
                      const anyFeeQuestionAnswered = this.checkAnyFeeQuestionAnswered(values);

                      this.setState({
                        prevValues: values,
                        questionsFee: calculatedFee,
                        anyFeeQuestions: anyFeeQuestionAnswered
                      }, () => {
                        // Update payment step visibility after state updates
                        this.updatePaymentStepVisibility(anyFeeQuestionAnswered);
                      });
                    }
                  }, [values]);

                  return (
                    <>
                      <Form>
                        <React.Fragment>
                          {/* Step {this.state.currentStep} */}
                          <div className="box">
                            <div className="steps">
                              <ul className="nav">
                                {this.state.steps.map((step, i) => {
                                  return (
                                    <li
                                      key={i}
                                      className={`${this.state.activeStep.key === step.key
                                        ? "active"
                                        : ""
                                        } ${step.isDone ? "done" : ""}`}
                                    >
                                      <div className="liChildDiv">
                                        <span className="stepNumber">
                                          Step {i + 1}
                                        </span>
                                        <br />
                                        <span className="stepDetail">
                                          {step.label}
                                        </span>
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>

                            {/* // Render the form steps and pass in the required props */}
                            <StepOne currentStep={currentStep} steps={steps} />

                            {/* Banner for admin-registered payment completion - Only show on Step 1 */}
                            {registrationRow &&
                             registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember &&
                             currentStep === steps.findIndex((i) => i.key == RegisWizardSteps.FirstStep) && (
                              <div className="alert alert-info d-flex align-items-center mb-3">
                                <i className="fa fa-info-circle mr-2" style={{ fontSize: '1.5rem' }}></i>
                                <div>
                                  <strong>Registration submitted by Administrator</strong>
                                  <p className="mb-0 small">Review the details below and proceed to payment to confirm your registration.</p>
                                </div>
                              </div>
                            )}

                            {/* Admin Member Selection - Only show on Steps 1 and 2 when registering for others */}
                            {isRegisteringForOthers && (currentStep === firstStepIdx || currentStep === secondStepIdx) && (
                              <div className="row mb-4">
                                <div className="col-md-12">
                                  <div className="card border-primary">
                                    <div className="card-header bg-primary text-white">
                                      <h6 className="mb-0">
                                        <i className="fa fa-users mr-2"></i>
                                        Admin Registration
                                      </h6>
                                    </div>
                                    <div className="card-body">
                                      <div className="form-group">
                                        <label className="form-label font-weight-bold">
                                          Register for another member (optional)
                                          <small className="d-block text-muted mt-1">
                                            Leave empty to register for yourself
                                          </small>
                                        </label>
                                        <Autocomplete
                                          options={this.state.memberOptions || []}
                                          getOptionLabel={(option) =>
                                            option ? `${option.name || `${option.firstName || ""} ${option.lastName || ""}`.trim()} - ${option.region}/${option.facility}` : ""
                                          }
                                          value={(this.state.memberOptions && this.state.memberOptions.find(m => m.id === this.state.selectedTargetMemberId)) || null}
                                          onChange={this.handleTargetMemberSelection}
                                          onInputChange={(e, value) => this.memberSearchHandler(value)}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label="Search and select member"
                                              variant="outlined"
                                              placeholder="Type member name to search..."
                                              fullWidth
                                            />
                                          )}
                                        />
                                        {this.state.selectedTargetMemberName && (
                                          <div className="mt-2">
                                            <div className="alert alert-success mb-0">
                                              <i className="fa fa-check-circle mr-2"></i>
                                              <strong>Selected:</strong> {this.state.selectedTargetMemberName}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            {/* Step Two has Dynamic Questions */}
                            <StepTwo
                              currentStep={this.state.currentStep}
                              erros={errors}
                              setValues={setValues}
                              values={values}
                              steps={steps}
                              isPendingPaymentByTarget={registrationRow && registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember}
                              isDisabled={(() => {
                                // Special case: PendingPaymentByTargetMember should have read-only questions
                                if (registrationRow && registrationRow.regisStatusId === RegistrationStatuses.PendingPaymentByTargetMember) {
                                  return true; // Questions are disabled (read-only) for payment completion
                                }

                                // Normal edit mode for InProgress and PendingRegistration
                                return (
                                  registrationRow &&
                                  registrationRow.regisStatusId !=
                                  RegistrationStatuses.InProgress &&
                                  registrationRow.regisStatusId !=
                                  RegistrationStatuses.PendingRegistration &&
                                  regisExists
                                );
                              })()}
                            />

                            {/* Show payment deferral badge for admin registrations with fees */}
                            {(() => {
                              const secondStepIndex = steps.findIndex((i) => i.key === RegisWizardSteps.SecondStep);

                              // Calculate fee in real-time based on current form values
                              const calculatedFee = this.calculateQuestionsFee(values);
                              const anyFeeQuestionAnswered = this.checkAnyFeeQuestionAnswered(values);

                              const shouldShowBadge = isRegisteringForOthers &&
                                this.state.selectedTargetMemberId &&
                                this.state.currentStep === secondStepIndex &&
                                (calculatedFee > 0 || anyFeeQuestionAnswered);

                              console.log('PaymentDeferralBadge Debug:', {
                                isRegisteringForOthers,
                                selectedTargetMemberId: this.state.selectedTargetMemberId,
                                currentStep: this.state.currentStep,
                                secondStepIndex,
                                calculatedFee,
                                anyFeeQuestionAnswered,
                                shouldShowBadge
                              });

                              return shouldShowBadge && (
                                <PaymentDeferralBadge
                                  targetMemberName={this.state.selectedTargetMemberName}
                                  questionsFee={calculatedFee}
                                />
                              );
                            })()}

                            {/* Step Three has Payment Screen */}

                            <div ref={this.portalRef} />
                            {/* Show appropriate success component based on registration type */}
                            {isRegisteringForOthers && this.state.selectedTargetMemberId ? (
                              <AdminDeferredPaymentSuccess
                                currentStep={currentStep}
                                steps={steps}
                                targetMemberName={this.state.selectedTargetMemberName}
                                questionsFee={this.state.questionsFee || 0}
                              />
                            ) : (
                              <SucessfulPayment
                                currentStep={currentStep}
                                isFinishedPaymentFlow={
                                  this.state.isFinishedPaymentFlow
                                }
                                steps={steps}
                              />
                            )}
                          </div>
                        </React.Fragment>
                        <div className="card-footer text-center border-top-0">
                          {registrationRow &&
                            this.props.regTableType ==
                            RegistrationTableTypes.MyRegistrations &&
                            (registrationRow.regisStatusId ==
                              RegistrationStatuses.InProgress ||
                              registrationRow.regisStatusId ==
                              RegistrationStatuses.PendingRegistration) && (
                              <button
                                type="button"
                                className="btn btn-primary mr-1 cancelModal bg-danger"
                                onClick={() =>
                                  RegistrationsService.CancelRegistration(
                                    registrationRow.id
                                  )
                                }
                              >
                                Cancel Reg.
                              </button>
                            )}
                          <button
                            type="button"
                            className="btn btn-primary mr-1 cancelModal"
                            onClick={this.handleClose}
                          >
                            Close
                          </button>
                          {(currentStep == firstStepIdx ||
                            currentStep == secondStepIdx) &&
                            ((registrationRow &&
                              (registrationRow.regisStatusId ==
                                RegistrationStatuses.InProgress ||
                                registrationRow.regisStatusId ==
                                RegistrationStatuses.PendingRegistration)) ||
                              !regisExists) && (
                              <button
                                type="submit"
                                disabled={!isValid}
                                className={`btn btn-success mr-1 wizardSubmit ${currentStep == secondStepIdx ? "" : "hidden"
                                  }`}
                              >
                                {this.state.isExecutePaymentFlow ? (
                                  <i
                                    class="fa fa-arrow-circle-right"
                                    aria-hidden="true"
                                  >
                                    Next
                                  </i>
                                ) : (
                                  "Submit"
                                )}
                              </button>
                            )}
                          {thirdStepIdx != -1
                            ? currentStep <= thirdStepIdx && this.previousButton
                            : this.previousButton}

                          {/* //Next Button// */}
                          {showNextButton && this.nextButton}
                        </div>
                      </Form>
                      <CloseRegistrationWizardModal
                        modal={this.state.showConfirmCloseRegModal}
                        confirm={this.confirmCancelRegModal}
                        toggle={this.toggleShowConfirmCloseRegModal}
                        justCloseRegModal={this.justCloseRegModal}
                        regTableType={this.props.regTableType}
                        registrationRow={registrationRow}
                        cancelRegistration={
                          RegistrationsService.CancelRegistration
                        }
                        submitFormData={handleSubmit}
                        isFormValid={isValid}
                        setFormErrors={setErrors}
                        currentStep={this.state.currentStep}
                      />
                    </>
                  );
                }}
              </Formik>

              {/* Show registration type label on Step 3 (Payment) for admins with on-behalf permission */}
              {isRegisteringForOthers &&
               currentStep === thirdStepIdx &&
               this.state.isExecutePaymentFlow && (
                <div className="alert alert-info d-flex align-items-center mb-3">
                  <i className="fa fa-user-circle mr-2" style={{ fontSize: '1.5rem' }}></i>
                  <div>
                    {this.state.selectedTargetMemberId && this.state.selectedTargetMemberName ? (
                      // On-behalf registration (shouldn't reach Step 3, but handle just in case)
                      <><strong>Registering for:</strong> {this.state.selectedTargetMemberName}</>
                    ) : (
                      // Self-registration by admin
                      <><strong>Registration Type:</strong> Self-Registration</>
                    )}
                  </div>
                </div>
              )}

              {this.state.isExecutePaymentFlow && (
                <Portal container={this.portalRef.current}>
                  <StepThree
                    currentStep={this.state.currentStep}
                    nextStep={this._next}
                    steps={steps}
                    closeRegistrationModal={this.props.onClose}
                    occasionId={occasionId}
                    registrationId={registrationId}
                    isFinishedPaymentFlow={this.state.isFinishedPaymentFlow}
                    questionsFee={this.state.questionsFee}
                  />
                </Portal>
              )}
            </>
          </Modal.Body>
        )
        }
      </Modal>
    );
  }
}
export default withRouter(
  connect(
    (state) => ({
      registrationsState: state.registrations,
    }),
    {
      ...registrationsAction,
    }
  )(RegisterMemberModal)
);
